import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
//import 'swiper/css/navigation';
import 'swiper/css/pagination';
//import 'swiper/css/scrollbar';


jQuery(document).ready(function($) {
    let height;
    const $phases = $('.phases');
    const $slides = $('.phasesCarouselSlide');

    if ( !$phases.length ) {
        return;
    }

    const phasesSwiper = new Swiper('.phasesCarousel .swiper', {
        modules: [Scrollbar],
        spaceBetween: 15,
        autoHeight: true,
        simulateTouch: false,
        breakpoints: {
            720: {
                spaceBetween: 0,
            },
            1120: {
                autoHeight: false,
                scrollbar: {
                    draggable: false,
                }
            }
        },
        loop: false,
        scrollbar: {
            el: '.phasesCarousel__scrollbar',
            draggable: true,
            hide: false,
        }
    });

    if (innerWidth < 1120) {
        return;
    }

    function calcHeight() {
        height = 0;
        $slides.each(function(index, element) {
            height = Math.max($(element).outerHeight(), height);
        });
        height = height * ($slides.length + 1);
        $phases.css('height', height);
    }
    calcHeight();
    $(window).on('resize', calcHeight);


    $(window).on('load scroll', function() {
        if ( scrollY > $phases.offset().top ) {
            let scroll = scrollY - $phases.offset().top;
            let index = Math.floor(scroll / (height / ($slides.length+1)));
            phasesSwiper.slideTo(index);
        }
    });



})